export default __webpack_public_path__ + "static/media/react.b37f0a4b.png";